(function () {
  'use strict';

  var TARGET_COUNTRY = 'SA';
  var TARGET_CITY = 'Riyadh';
  var START_HOUR = 10;
  var END_HOUR = 20;
  var KSA_OFFSET = 3;

  function isWithinKsaHours() {
    var ksaHour = (new Date().getUTCHours() + KSA_OFFSET) % 24;
    return ksaHour >= START_HOUR && ksaHour < END_HOUR;
  }

  function isRiyadh(geo) {
    if (!geo) return false;
    return (geo.country || '').toUpperCase() === TARGET_COUNTRY &&
           (geo.city || '').toLowerCase() === TARGET_CITY.toLowerCase();
  }

  // Whether this visitor is eligible (cached per page-load once resolved)
  var eligible = null;
  function checkEligibility() {
    if (eligible !== null) return Promise.resolve(eligible);
    if (!isWithinKsaHours()) { eligible = false; return Promise.resolve(false); }
    if (!window.ShopaleenaGeo) return Promise.resolve(false);
    return window.ShopaleenaGeo.get().then(function (geo) {
      eligible = isRiyadh(geo);
      return eligible;
    });
  }

  // Show/hide every express-delivery element currently in the DOM
  function applyVisibility() {
    checkEligibility().then(function (ok) {
      document.querySelectorAll('[data-express-delivery]').forEach(function (el) {
        if (ok) {
          el.removeAttribute('hidden');
          bindToggle(el);
        } else {
          el.setAttribute('hidden', '');
        }
      });
    });
  }

  var busy = false;
  function bindToggle(container) {
    var btn = container.querySelector('.express-toggle');
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = 'true';

    btn.addEventListener('click', function () {
      if (busy) return;
      busy = true;
      btn.classList.add('is-loading');

      var variantId = container.getAttribute('data-variant-id');
      var turningOn = !btn.classList.contains('is-on');

      var body = turningOn
        ? { items: [{ id: Number(variantId), quantity: 1 }] }
        : { id: String(variantId), quantity: 0 };
      var url = turningOn ? '/cart/add.js' : '/cart/change.js';

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        // This theme's cart refresh API — re-fetches the section and
        // re-renders the drawer (including our Liquid toggle with correct state).
        var cartForm = document.querySelector('cart-drawer cart-form');
        if (cartForm && typeof cartForm.refresh === 'function') {
          cartForm.refresh();
        } else {
          // Fallback to the documented event
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }
      })
      .catch(function (err) { console.warn('[express] failed:', err); })
      .then(function () {
        btn.classList.remove('is-loading');
        busy = false;
      });
    });
  }

  function init() { applyVisibility(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('geo:ready', applyVisibility);

  // This theme re-renders the footer on cart updates — re-apply after each.
  // Watch the cart-drawer for DOM changes and re-run visibility/binding.
  var drawer = document.querySelector('cart-drawer');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () { applyVisibility(); })
      .observe(drawer, { childList: true, subtree: true });
  }
})();